import { useEffect, useLayoutEffect, useRef, useState } from "react";

// Tiempos configurables
const REVEAL_START_DELAY_MS = 1000;   // retardo antes de iniciar el fade/reveal
const REVEAL_FADE_DURATION_MS = 900; //800  // duración del fade

/**
 * Animaciones:
 * 0 = ninguno
 * 1 = overlay negro que se desvanece
 * 2 = overlay negro + varita girando en órbita mientras se desvanece
 * 3 = overlay negro en 4 cuadrantes que se abren hacia fuera
 */
const SelfieFanIA = ({ selfieFan, isActiveWomensMode }) => {
  const prevSrcRef = useRef(["", ""]);
  const revealedRef = useRef([false, false]);

  const [overlayState, setOverlayState] = useState([
    { active: false, fading: false, anim: 0 },
    { active: false, fading: false, anim: 0 },
  ]);

  const [uiReady, setUiReady] = useState(false);

  const timersRef = useRef([null, null]);

  const clearTimers = () => {
    timersRef.current.forEach((t, i) => {
      if (t) {
        clearTimeout(t);
        timersRef.current[i] = null;
      }
    });
  };

  const triggerForIndex = (idx, imgObj) => {
    if (timersRef.current[idx]) {
      clearTimeout(timersRef.current[idx]);
      timersRef.current[idx] = null;
    }

    const src  = imgObj?.image || "";
    const anim = Number(imgObj?.animation ?? 0);

    if (!src) {
      prevSrcRef.current[idx] = "";
      revealedRef.current[idx] = false;
      setOverlayState((prev) => {
        const next = [...prev];
        next[idx] = { active: false, fading: false, anim: 0 };
        return next;
      });
      return;
    }

    const isSameImage = prevSrcRef.current[idx] === src;
    const wasRevealed = revealedRef.current[idx] === true;

    if (isSameImage && wasRevealed) {
      setOverlayState((prev) => {
        const next = [...prev];
        next[idx] = { active: false, fading: false, anim: 0 };
        return next;
      });
      return;
    }

    prevSrcRef.current[idx] = src;

    if (anim === 0) {
      revealedRef.current[idx] = true;
      setOverlayState((prev) => {
        const next = [...prev];
        next[idx] = { active: false, fading: false, anim: 0 };
        return next;
      });
      return;
    }

    revealedRef.current[idx] = false;
    setOverlayState((prev) => {
      const next = [...prev];
      next[idx] = { active: true, fading: false, anim };
      return next;
    });

    timersRef.current[idx] = setTimeout(() => {
      setOverlayState((prev) => {
        const next = [...prev];
        next[idx] = { active: true, fading: true, anim };
        return next;
      });

      timersRef.current[idx] = setTimeout(() => {
        revealedRef.current[idx] = true;
        setOverlayState((prev) => {
          const next = [...prev];
          next[idx] = { active: false, fading: false, anim: 0 };
          return next;
        });
        timersRef.current[idx] = null;
      }, REVEAL_FADE_DURATION_MS);
    }, REVEAL_START_DELAY_MS);
  };

  useLayoutEffect(() => {
    setUiReady(false);
    clearTimers();

    const imgs = selfieFan?.images || [];
    triggerForIndex(0, imgs[0] || null);
    triggerForIndex(1, imgs[1] || null);

    const raf = requestAnimationFrame(() => setUiReady(true));

    return () => {
      clearTimers();
      cancelAnimationFrame(raf);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selfieFan?.images, selfieFan?.isActiveWomensMode]);

  useLayoutEffect(() => {
    try { document.getElementById("root").classList.add("BodyComplete"); } catch {}
  }, []);

  const getImageSrc = (idx) => {
    const imgs = selfieFan?.images || [];
    const src = imgs[idx]?.image || "";
    if (src) return src;
    return "/img/selfiefan/Fondo-Azul-Five-Screen.png";
  };

  //const isWomens = !!selfieFan?.isActiveWomensMode;

  return (
    <>
      <div className="SelfieFan__Screen__Selfie__Background">
        {isActiveWomensMode ? (
          <img src="/img/selfiefan/Fondo-SelfieFan-Femenil.png" className="SelfieFan__Screen__Selfie__Background__Image" alt="" />
        ) : isActiveWomensMode === false && (
          <img src="/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png" className="SelfieFan__Screen__Selfie__Background__Image" alt="" />
        )}
        {/* <img src='/img/page/backgrounds/valentines-day-2026/heart-balloons-background.png' className='SelfieFan__Screen__Selfie__Background__Image' /> */}
      </div>

      <div className="SelfieFan__Screen__Selfie__Box SelfieFan__Screen__Selfie__Up">
        <div className="SelfieFan__Screen__Selfie__Container">
          {!selfieFan?.images || selfieFan.images.length === 0 ? (
            <Instructions />
          ) : (
            <>
              <div className="SelfieFanIA__Screen__Selfie__Images">
                <ImageWithOverlay
                  src={getImageSrc(0)}
                  anim={overlayState[0]}
                  alt="Imagen 1"
                  uiReady={uiReady}
                />
                <ImageWithOverlay
                  src={getImageSrc(1)}
                  anim={overlayState[1]}
                  alt="Imagen 2"
                  uiReady={uiReady}
                />
              </div>

              <div className="SelfieFanIA__Screen__Selfie__Container__Instructions mx-auto">
                <img src="/img/selfiefan/IADSL.png" className="SelfieFanIA__Screen__Selfie__Container__Instructions__Logo" alt="" />
                {/* <img src="/img/page/qr/selfie-fan-qr-fondo-gris-con-parametros.png" className="SelfieFanIA__Screen__Selfie__Container__Instructions__QR" alt="QR" /> */}
                <img src="/img/page/qr/selfie-fan-qr-fondo-gris-sin-parametros.png" className="SelfieFanIA__Screen__Selfie__Container__Instructions__QR" alt="QR" />
                <p className="SelfieFanIA__Screen__Selfie__Container__Instructions__Text" style={{ fontFamily: '"GFS Didot", serif' }}>
                  ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA
                </p>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Globo superiores de Lucho Fest */}
      {/* <figure className='SelfieFanIA__Screen__Balloons--Top'>
        <img src='/img/selfiefan/luchoFest/balloons-top-fancam-ia.png' className='SelfieFanIA__Screen__Balloons__Image' />
      </figure> */}

      {/* Globos inferiores de Lucho Fest */}
      {/* <figure className='SelfieFanIA__Screen__Balloons--Bottom'>
        <img src='/img/selfiefan/luchoFest/balloons-bottom-fancam-ia.png' className='SelfieFanIA__Screen__Balloons__Image' />
      </figure> */}

      <footer className="SelfieFan__Screen__Selfie__Footer FooterCredits">
        Hecho con ♥ por Interaktia | 2026
      </footer>
    </>
  );
};

const Instructions = () => (
  <div className="SelfieFan__Screen__Selfie__Container__Instructions mx-auto">
    <img src="/img/selfiefan/Adsl-FanCam.png" className="SelfieFan__Screen__Selfie__Container__Instructions__Logo" alt="" />
    <p className="SelfieFan__Screen__Selfie__Container__Instructions__Text" style={{ fontFamily: '"GFS Didot", serif' }}>
      ¡VAMOS CON TODO EQUIPO!
    </p>
  </div>
);

const ImageWithOverlay = ({ src, anim, alt, uiReady }) => {
  return (
    <div className="SelfieFanIA__Screen__Selfie__Images__Item">
      <img
        src={src}
        className="SelfieFanIA__Screen__Selfie__Images__Image"
        alt={alt}
        style={{ visibility: uiReady ? "visible" : "hidden" }}
        loading="eager"
      />

      {anim.active && (
        <Overlay type={anim.anim} fading={anim.fading} />
      )}
    </div>
  );
};

const Overlay = ({ type, fading }) => {
  // Común a 1,2,3: el contenedor cubre toda el área
  if (type === 1) {
    // Negro simple que se desvanece (ya lo tenías)
    return (
      <div
        className="SFIA-Overlay SFIA-Overlay--blackfade"
        style={{
          opacity: fading ? 0 : 1,
          transition: `opacity ${REVEAL_FADE_DURATION_MS}ms ease`,
        }}
      />
    );
  }

  if (type === 2) {
    // Negro + varita girando en órbita; el fondo también hace fade
    return (
      <div
        className="SFIA-Overlay SFIA-Overlay--blackfade"
        style={{
          opacity: fading ? 0 : 1,
          transition: `opacity ${REVEAL_FADE_DURATION_MS}ms ease`,
        }}
      >
        <div
          className="SFIA-WandOrbit"
          style={{
            animationDuration: `${REVEAL_START_DELAY_MS + REVEAL_FADE_DURATION_MS}ms`,
          }}
        >
          {/* <i className="bi bi-magic SFIA-WandIcon" /> */}
          <i className="bi bi-stars SFIA-WandIcon"></i>
        </div>
      </div>
    );
  }

  if (type === 3) {
    // Negro en 4 cuadrantes que se abren hacia fuera
    return (
      <div className="SFIA-Overlay SFIA-Overlay--quads">
        <div
          className={`SFIA-Quad SFIA-Quad--tl ${fading ? "is-open" : ""}`}
          style={{ transitionDuration: `${REVEAL_FADE_DURATION_MS}ms` }}
        />
        <div
          className={`SFIA-Quad SFIA-Quad--tr ${fading ? "is-open" : ""}`}
          style={{ transitionDuration: `${REVEAL_FADE_DURATION_MS}ms` }}
        />
        <div
          className={`SFIA-Quad SFIA-Quad--bl ${fading ? "is-open" : ""}`}
          style={{ transitionDuration: `${REVEAL_FADE_DURATION_MS}ms` }}
        />
        <div
          className={`SFIA-Quad SFIA-Quad--br ${fading ? "is-open" : ""}`}
          style={{ transitionDuration: `${REVEAL_FADE_DURATION_MS}ms` }}
        />
      </div>
    );
  }

  // Por defecto: nada
  return null;
};

export { SelfieFanIA };










// const SelfieFanIA = ({ selfieFan }) => {

//     const LoadPage = async () => {
//         try {
//             document.getElementById("root").classList.add("BodyComplete")
//         } catch (error) {
            
//         }
//     }

//     useEffect(() => {
//         LoadPage()
//     }, [])
    

//     return (
//         <>
//             <div className='SelfieFan__Screen__Selfie__Background'>
//                 {selfieFan?.isActiveWomensMode ? (
//                     <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='SelfieFan__Screen__Selfie__Background__Image' />
//                 ) : (
//                     <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='SelfieFan__Screen__Selfie__Background__Image' />
//                 )}
//             </div>

//             <div className='SelfieFan__Screen__Selfie__Box SelfieFan__Screen__Selfie__Up'>
//                 <div className='SelfieFan__Screen__Selfie__Container'>
//                     {selfieFan ? (
//                         selfieFan?.images ? (
//                             selfieFan?.images?.length === 0 ? (
//                                 <div className='SelfieFan__Screen__Selfie__Container__Instructions mx-auto'>
//                                     <img src='/img/selfiefan/Adsl-FanCam.png' className='SelfieFan__Screen__Selfie__Container__Instructions__Logo' />
//                                     <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>¡VAMOS CON TODO EQUIPO!</p>
//                                 </div>
//                             ) : (
//                                 <>
//                                     <div className='SelfieFanIA__Screen__Selfie__Images'>
//                                         {selfieFan?.images[0]?.image ? (
//                                             <img src={selfieFan?.images[0]?.image} className='SelfieFanIA__Screen__Selfie__Images__Image' />
//                                         ) : (
//                                             <>
//                                                 {selfieFan?.isActiveWomensMode ? (
//                                                     // <img src='/img/selfiefan/Fondo-Oro-Screen.png' className='SelfieFanIA__Screen__Selfie__Images__Image' />
//                                                     <img src='/img/selfiefan/Fondo-Azul-Five-Screen.png' className='SelfieFanIA__Screen__Selfie__Images__Image' />
//                                                 ) : (
//                                                     // <img src='/img/selfiefan/Fondo-Rojo-Screen.png' className='SelfieFanIA__Screen__Selfie__Images__Image' />
//                                                     <img src='/img/selfiefan/Fondo-Azul-Five-Screen.png' className='SelfieFanIA__Screen__Selfie__Images__Image' />
//                                                 )}
//                                             </>
//                                         )}

//                                         {selfieFan.images.length === 2 ? (
//                                             selfieFan?.images[1]?.image ? (
//                                                 <img src={selfieFan?.images[1]?.image} className='SelfieFanIA__Screen__Selfie__Images__Image' />
//                                             ) : (
//                                                 <>
//                                                     {selfieFan?.isActiveWomensMode ? (
//                                                         // <img src='/img/selfiefan/Fondo-Oro-Screen.png' className='SelfieFanIA__Screen__Selfie__Images__Image' />
//                                                         <img src='/img/selfiefan/Fondo-Azul-Five-Screen.png' className='SelfieFanIA__Screen__Selfie__Images__Image' />
//                                                     ) : (
//                                                         // <img src='/img/selfiefan/Fondo-Rojo-Screen.png' className='SelfieFanIA__Screen__Selfie__Images__Image' />
//                                                         <img src='/img/selfiefan/Fondo-Azul-Five-Screen.png' className='SelfieFanIA__Screen__Selfie__Images__Image' />
//                                                     )}
//                                                 </>
//                                             )
//                                         ) : (
//                                             <>
//                                                 {selfieFan?.isActiveWomensMode ? (
//                                                     // <img src='/img/selfiefan/Fondo-Oro-Screen.png' className='SelfieFanIA__Screen__Selfie__Images__Image' />
//                                                     <img src='/img/selfiefan/Fondo-Azul-Five-Screen.png' className='SelfieFanIA__Screen__Selfie__Images__Image' />
//                                                 ) : (
//                                                     // <img src='/img/selfiefan/Fondo-Rojo-Screen.png' className='SelfieFanIA__Screen__Selfie__Images__Image' />
//                                                     <img src='/img/selfiefan/Fondo-Azul-Five-Screen.png' className='SelfieFanIA__Screen__Selfie__Images__Image' />
//                                                 )}
//                                             </>
//                                         )}
//                                     </div>
                                    
//                                     <div className={`SelfieFanIA__Screen__Selfie__Container__Instructions ${!selfieFan.image === 'mx-auto'}`}>
//                                         <img src='/img/selfiefan/IADSL.png' className='SelfieFanIA__Screen__Selfie__Container__Instructions__Logo' />
//                                         <img src='/img/page/qr/selfie-fan-qr-fondo-gris-con-parametros.png' className='SelfieFanIA__Screen__Selfie__Container__Instructions__QR' />
//                                         <p className='SelfieFanIA__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA</p>
//                                     </div>
//                                 </>
//                             )
//                         ) : (
//                             <div className='SelfieFan__Screen__Selfie__Container__Instructions mx-auto'>
//                                 <img src='/img/selfiefan/Adsl-FanCam.png' className='SelfieFan__Screen__Selfie__Container__Instructions__Logo' />
//                                 <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>¡VAMOS CON TODO EQUIPO!</p>
//                             </div>
//                         )
//                     ) : (
//                         <div className='SelfieFan__Screen__Selfie__Container__Instructions mx-auto'>
//                             <img src='/img/selfiefan/Adsl-FanCam.png' className='SelfieFan__Screen__Selfie__Container__Instructions__Logo' />
//                             <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>¡VAMOS CON TODO EQUIPO!</p>
//                         </div>
//                     )}
//                 </div>
//             </div>

//             <footer className='SelfieFan__Screen__Selfie__Footer'>Hecho con ♥ por Interaktia | 2026</footer>
//         </>
//     )
// }

// export { SelfieFanIA };